
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/loyalty_scan",
      function () {
        return require("private-next-pages/loyalty_scan.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/loyalty_scan"])
      });
    }
  